import Configurator from 'bookingbug-configurator-js';
import { bbAnalytics } from './analytics.service.handler';
import { GoogleAnalyticsProvider } from '../providers/GoogleAnalyticsProvider';
// import { PiwikProvider } from '../providers/PiwikProvider';

import AppConfig from '../../../App.config';
import AppSchema from '../../../App.schema';

import ExternalSchema from './external-analytics.schema';
import ExternalConfig from './external-analytics.config';

import InternalConfig from './internal-analytics.config';

Configurator.newSchema(AppSchema);
Configurator.newSchema(ExternalSchema);

const Environment = {
  get isProduction() {
    return process.env.NODE_ENV === 'production' && !window.location.pathname.includes('development') && !window.location.pathname.includes('staging');
  },
  isTestMode: false,
};

function shouldAnalyticsRun({ environment, isProduction, isTestMode }) {
  return environment === 'production' && isProduction && !isTestMode;
}

function bootstrapExternalProvider(analyticsConfiguration) {
  switch (analyticsConfiguration.provider.type) {
    // case PiwikProvider.name:
    default:
      // PiwikProvider.bootstrap(analyticsConfiguration.provider);
      break;
  }
}

/**
   * External analytics is not meant to be tracking 'errors',
   * so we safely filter that key out
   * @param object The object to be filtered
   * @returns {*} The object without the errors key
   */
function ignoreErrorsConfiguration(object) {
  if (Object.keys(object).length === 0) {
    return object;
  }
  return Object.keys(object)
    .filter((key) => key !== 'errors')
    .reduce((obj, key) => ({ ...obj, [key]: object[key] }), {});
}


function bootstrapAnalytics() {
  const { environment } = Configurator;
  const { isProduction, isTestMode } = Environment;

  if (shouldAnalyticsRun({ environment, isProduction, isTestMode })) {
    Configurator.loadDefault(AppConfig);
    Configurator.loadDefault(ExternalConfig);

    // Read all sources of analytics configuration: general, internal and external.
    const generalModuleSettings = Configurator.getConfig('bbGeneralOptions.analytics');
    const internalConfiguration = InternalConfig.bbAnalytics;
    const externalConfiguration = Configurator.getConfig('bbAnalytics');

    const providerTypes = {
      GoogleAnalytics: GoogleAnalyticsProvider,
      // /  Piwik: PiwikProvider,
    };

    // Creating providers array with a internal provider that's always present.
    const providers = [];

    // Adding external provider if it was configured.
    const isExternalProviderEnabled = generalModuleSettings.enable;
    const isInternalProviderEnabled = generalModuleSettings.enableInternal;

    if (isInternalProviderEnabled) {
      const internal = new GoogleAnalyticsProvider(internalConfiguration, internalConfiguration.provider.id, 'internal');
      providers.push(internal);
    }

    if (isExternalProviderEnabled) {
      bootstrapExternalProvider(generalModuleSettings);
      const { type = {}, id } = generalModuleSettings.provider;

      const external = new providerTypes[type](externalConfiguration, id, 'external');
      providers.push(external);
    }

    // Configure analytics service with both elements configurations.
    const externalAnalyticsElements = ignoreErrorsConfiguration(
      externalConfiguration.elements || {},
    );

    const internalAnalyticsElements = internalConfiguration.elements || {};

    providers.forEach((provider) => {
      const elements = provider.providerName.includes('internal')
        ? internalAnalyticsElements
        : externalAnalyticsElements;

      bbAnalytics.setProviderData(provider.providerName, provider, elements);
    });
  }
}


export { bootstrapAnalytics, shouldAnalyticsRun };
